module.exports = __webpack_public_path__ + "media/application/images/perish/title-3000-ec065968a4cafdd2f5196f9ec172ea0b.png";